import Api from '@/services/api';

export default {
  get(id) {
    return Api().get('/client/settlement/' + id);
  },
  
}